import { render } from "./tournaments.template.html?vue&type=template&id=09941cb9&scoped=true"
import script from "./Tournaments.vue?vue&type=script&lang=ts"
export * from "./Tournaments.vue?vue&type=script&lang=ts"

import "./Tournaments.vue?vue&type=style&index=0&id=09941cb9&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-09941cb9"

export default script